import BlotFormatter from "@enzedonline/quill-blot-formatter2";
import Quill from "quill";

/*
 * This module integrates the BlotFormatter with the Quill editor
 * mainly to enable image resizing, but it can also handle other blot types.
 *
 * Read more about blots: https://github.com/slab/parchment#blots
 *
 * The module provides functionality for resizing and aligning blots.
 *
 * There are bunch of such modules available, but this one was (at the time) maintained
 * and worked well with the latest Quill version (v2).
 *
 * This makes a global registration of the module.
 *
 * Add to PrimeNG Quill editor like this:
 *
 * In component:
 *
 * public editorModules = {
 *   blotFormatter2: {
 *     // See config options: https://github.com/enzedonline/quill-blot-formatter2/blob/v3.0.3/src/Options.ts
 *   }
 * }
 *
 * In template:
 * <p-editor [modules]="editorModules"></p-editor>
 */

Quill.register("modules/blotFormatter2", BlotFormatter);
